import { SetServiceDependencies } from '../../../infra/startup/types';
import ILogoutService from './ILogoutService';
import { LogoutOptionsType } from '../ISessionService';
import { CheckPathPropsType, IsLoggedoutPathPropsType } from './types';
import { INavigationService } from '../../../services/navigationService';
import matchPath from '../../../utils/matchPath';
import { LOGGEDOUT_PATHNAME } from '../constants';
import { ILocalizationService } from '../../../services/localizationService';

export default abstract class BaseLogoutService implements ILogoutService {
  protected _navigationService: INavigationService;
  protected _localizationService: ILocalizationService;

  public abstract setDependencies(options: SetServiceDependencies): void;
  public abstract logout(options?: LogoutOptionsType): Promise<void>;

  private getCurrentLocale(): string {
    const country = this._localizationService?.country;
    const language = this._localizationService?.language;
    if (country && language) return `/${country}/${language}`;
    return '';
  }

  protected getPostLogoutRedirectFallBack(): string {
    return this.getCurrentLocale();
  }

  private checkPath(props: CheckPathPropsType): boolean {
    let pathToCompare =
      props?.pathToCompare ||
      this?._navigationService?.location?.pathname ||
      '';
    if (!pathToCompare.startsWith('/')) pathToCompare = '/' + pathToCompare;
    return matchPath(props?.shellInternalPath, {
      exact: props?.exact,
      pathToCompare
    });
  }

  public isLoggedoutPath(options?: IsLoggedoutPathPropsType): boolean {
    return this.checkPath({
      pathToCompare: options?.pathToCheck,
      shellInternalPath: LOGGEDOUT_PATHNAME,
      exact: options?.exact
    });
  }
}
